import { createContext, useContext } from 'react';

export const AdministrationTableContext = {
  StateContext: createContext(undefined),
  DispatchContext: createContext(undefined),
};

export function useTableStateContext() {
  return useContext(AdministrationTableContext.StateContext);
}

export function useTableDispatchContext() {
  return useContext(AdministrationTableContext.DispatchContext);
}
